import React from 'react';

const Title = () => {
  return (
    <h1 style={{ textAlign: 'center', fontSize: '24px', marginBottom: '20px' }}>
      Create Your Application for a Tour!
    </h1>
  );
};

export default Title;
